import { Link } from 'react-router';

import ErrorPage from '../components/ErrorPage.jsx';
import ContentPage from '../components/ContentPage.jsx';

import { ErrorBoundary } from '@sentry/react';

function LegalTermsPage() {
  return (
    <ErrorBoundary fallback={ErrorPage}>
      <ContentPage title={'Terms of Use'}>
        <>
          <p>
            These terms relate to the use of Townsville.Today (referred to as "we", "our", or "us"). By accessing or using
            our website located at Townsville.Today (the "Website"), including any data, forecasts, or services provided
            through it, you agree to be bound by these Terms of Use. If you do not agree with these Terms, please do not
            use our Website.
          </p>
        <h2>1. Our Data and Information</h2>
          <p>
            Townsville.Today provides observations, forecasts, alerts, data visualisations, and related information
            (&#34;Services&#34;) for general informational purposes only. While we aim to provide accurate and timely weather
            information, the nature of meteorological forecasting, automated data collection and electronic transmission of
            this data means that no data can be guaranteed as 100% accurate or current.
          </p>
          <p>
            We strive to ensure that the weather data and forecasts displayed are as accurate as possible, using reputable
            data sources (see <Link to="/legal/data">our data sources</Link>). However, we make no representations or
            warranties of any kind, express or implied, about the reliability, accuracy, or availability of the
            Services. The information provided by Townsville.Today may include data which is not quality controlled or
            validated and may include errors or inaccuracies. Use of the Website and Services is at your own risk.
          </p>
          <p>
            Do not rely solely on the observations, forecasts, warnings or alerts on this platform for decision-making where
            safety, health, property protection or significant financial outcomes are involved. Always consult official
            sources such as the <a href="https://reg.bom.gov.au">Bureau of Meteorology</a>,
            the <a href="https://disaster.townsville.qld.gov.au/">Townsville Disaster Dashboard</a> or local emergency
            services for information and advice.
          </p>

        <h2>2. Use of the Website and Services</h2>
          <p>
            You agree to use the Website and Services only for lawful purposes and in a manner that does not infringe the
            rights of or restrict or inhibit the use and enjoyment of the Website by any third party.
          </p>
          <p>
          You must not:
          </p>
            <ul>
              <li>Use the Website to distribute any material that is unlawful, harassing, defamatory, abusive,
                threatening, harmful, vulgar, obscene, or otherwise objectionable.</li>
              <li>Use any automated system, software, or process to extract, scrape, or mine data from the Website
                without our prior written consent.</li>
              <li>Misrepresent or misuse the information or Services provided.</li>
            </ul>

          <h2>3. Intellectual Property</h2>
          <p>
            Data, content and materials on the Townsville.Today, including logos, graphics, weather data visualisations,
            and software, are owned by or licensed to Townsville.Today and protected under Australian and
            international intellectual property laws unless otherwise stated. You may not reproduce, modify, transmit,
            or distribute any part of the Website or Services without our prior written permission, except as allowed
            under the Copyright Act 1968.
          </p>

          <p>
            Some data and content on the Website are sourced from third parties under licence. Where applicable, these
            third-party providers retain ownership of their intellectual property rights, and may have additional terms
            and conditions that apply to reproduction or republication of their data.
          </p>

          <h2>4. Privacy</h2>
            <p>
              Your use of the Website is governed by our [Privacy Policy](insert link), which complies with the Privacy
              Act 1988 and the Australian Privacy Principles. By using our Website or Services, you consent to the
              collection, storage, and use of your personal information in accordance with that policy.
            </p>

            <p>
              We may collect non-personally identifiable data (e.g., browser type, location data, and usage statistics)
              to improve the quality of our Services. Any location-based services will require your express permission
              to access geolocation data.
            </p>

          <h2>5. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, Townsville.Today shall not be liable for any loss, damage, cost,
              or expense—whether direct, indirect, incidental, special, or consequential—arising out of or in
              connection with:
            </p>
            <ul>
              <li>
                the use or inability to use the Website or Services;
              </li>
              <li>
                decisions made based on weather data, forecasts, or other content provided;
              </li>
              <li>
                any delay, failure, interruption, or corruption of any data or service transmitted through the Website.
              </li>
            </ul>
            <p>
                Nothing in these Terms excludes, restricts, or modifies any right or remedy you may have under the Australian Consumer Law.
            </p>

          <h2>6. Changes to Terms</h2>
            <p>
              We may update or modify these Terms of Use at any time without prior notice. Any changes will be effective
              immediately upon being posted to the Website. Your continued use of the Website after changes are posted
              constitutes your acceptance of the revised Terms.
            </p>

          <h2>7. Contact Us</h2>
            <p>
              For questions or concerns regarding these Terms, please contact us:
            </p>
            <ul>
              <li>Email: <a href="mailto:legal@townsville.today">legal@townsville.today</a></li>
            </ul>
        </>
      </ContentPage>
    </ErrorBoundary>
  );
}

export default LegalTermsPage
